import { useEffect, useRef } from 'react';
import gsap from 'gsap';

export default function AnimatedNumber({ value, enableAnimations = true, visible = true }) {
    const elRef = useRef(null);
    const numRef = useRef({ val: 0 });
    const hasAnimated = useRef(false);

    const target = parseFloat(String(value).replace(/[^0-9.]/g, '')) || 0;
    const hasDecimal = String(value).includes('.');
    const suffix = typeof value === 'string' ? value.replace(/[0-9.]/g, '') : '';
    const isNum = !isNaN(target) && target > 0;

    useEffect(() => {
        if (!enableAnimations || !isNum || hasAnimated.current) return;
        if (visible === false) return;

        hasAnimated.current = true;
        numRef.current.val = 0;

        gsap.to(numRef.current, {
            val: target,
            duration: 1.8,
            ease: 'power2.out',
            onUpdate: () => {
                if (elRef.current) {
                    elRef.current.textContent = hasDecimal
                        ? numRef.current.val.toFixed(1) + suffix
                        : Math.round(numRef.current.val).toLocaleString() + suffix;
                }
            }
        });

        return () => gsap.killTweensOf(numRef.current);
    }, [enableAnimations, isNum, target, visible]);

    if (!enableAnimations || !isNum) return <>{value}</>;
    return <span ref={elRef}>0{suffix}</span>;
}
